import { Action } from "redux";
import { isActionType } from "./utils.js";

const ActionTypeKeys = ["SET_EDITOR_ACTIVE_STATE"] as const;

type ActionType = (typeof ActionTypeKeys)[number];
type ActionBase<T extends ActionType> = Action<T>;

type SetEditorActiveState = ActionBase<"SET_EDITOR_ACTIVE_STATE"> & {
  moduleId: string;
  isActive: boolean;
};

export type RichEditorAction = SetEditorActiveState;

export const isRichEditorAction = (
  action: Action,
): action is RichEditorAction => isActionType(action, ActionTypeKeys);

export const setEditorActiveState = (
  moduleId: string,
  isActive: boolean,
): SetEditorActiveState => ({
  type: "SET_EDITOR_ACTIVE_STATE",
  moduleId,
  isActive,
});
